import type DxfArrayScanner from '../DxfArrayScanner';
import type { ScannerGroup } from '../DxfArrayScanner';
import parseEntities from '../entities';
import parsePoint from '../shared/parsePoint';
import { ensureHandle } from '../shared';
import isMatched from '../shared/isMatched';

export function parseBlock(curr: ScannerGroup, scanner: DxfArrayScanner) {
    const block: any = {};
    let current = curr;

    while (!isMatched(current, 0, 'EOF')) {
        if (isMatched(current, 0, 'ENDBLK')) {
            // 당장 ENDBLK 파싱이 없어서 임시로 대충 소비함
            // 소비 안하면 ENTITY에 딸려들어가서 문제 생김
            current = scanner.next();
            while (!isMatched(current, 0, 'EOF')) {
                if (isMatched(current, 100, 'AcDbBlockEnd')) {
                    return block;
                }
                current = scanner.next();
            }
            break;
        }

        switch (current.code) {
            case 1:
                block.xrefPath = current.value;
                break;
            case 2:
                block.name = current.value;
                break;
            case 3:
                block.name2 = current.value;
                break;
            case 5:
                block.handle = current.value;
                break;
            case 8:
                block.layer = current.value;
                break;
            case 10:
                block.position = parsePoint(scanner);
                break;
            case 67:
                block.paperSpace = current.value && current.value === 1;
                break;
            case 70:
                if (current.value !== 0) {
                    block.type = current.value;
                }
                break;
            case 100:
                // ignore class markers
                break;
            case 330:
                block.ownerHandle = current.value;
                break;
            case 0:
                block.entities = parseEntities(current, scanner);
                break;
            default:
                break;
        }

        current = scanner.next();
    }
    return block;
}

export function parseBlocks(curr: ScannerGroup, scanner: DxfArrayScanner) {
    const blocks: any = {};
    let current = curr;
    while (!isMatched(current, 0, 'EOF')) {
        if (isMatched(current, 0, 'ENDSEC')) {
            break;
        }

        if (isMatched(current, 0, 'BLOCK')) {
            current = scanner.next();
            const block = parseBlock(current, scanner);

            ensureHandle(block);
            if (block.name) {
                blocks[block.name] = block;
            }
        }

        current = scanner.next();
    }
    return blocks;
}
